import { cnpj as cnpjValidator } from 'cpf-cnpj-validator'

type ValidateCnpjProps = {
  cnpj: string
}

export function validateCnpj({ cnpj }: ValidateCnpjProps): boolean {
  return cnpjValidator.isValid(cnpj)
}
